import { createStore, type StoreWritable } from 'effector'
import { persist } from 'effector-storage'

import type { PortalProfile } from '@portal/portal-api'

import { $portalProfile } from '@/entities/profile/portal'
import { localstorage } from '@/shared/lib/local-storage'
import { isNotNull } from '@/shared/lib/types'

export function createProfileLocalStore(defaultValue: number, key: string): StoreWritable<number> {
    const $store = createStore(defaultValue)

    persist({
        store: $store,
        key: key,
        adapter: profileLocalStorageAdapter,
        pickup: $portalProfile.updates.filter({ fn: isNotNull }),
    })

    return $store
}

function profileLocalStorageAdapter(key: string) {
    return {
        get: (): any => {
            const profile = $portalProfile.getState()!
            const storageKey = getStorageKey(profile, key)

            return Number(localstorage.getItem(storageKey)) || 0
        },
        set: (value: any) => {
            const profile = $portalProfile.getState()!
            const storageKey = getStorageKey(profile, key)

            localstorage.setItem(storageKey, value)
        },
    }
}

function getStorageKey(profile: PortalProfile, key: string) {
    return `${profile.publicId}_${key}`
}

export function checkShowTime(showTimestamp: number) {
    if (!showTimestamp) {
        return true
    }

    const diffMS = Date.now() - showTimestamp
    const diffHours = Math.floor(diffMS / 1000 / 60 / 60)

    return diffHours > 24
}
